<template>
  <div class="modal modal-blur fade" v-bind:id="dlgId" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Preview</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <img style="max-width: 100%" v-if="objectURL" v-bind:src="objectURL" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      dlgId: {
        type: String,
      },
      imageBlob: {
          type: Blob,
      },
    },
    
    data() {
      return {
        objectURL: null
      };
    },
    
    destroy() {
      if(this.objectURL) {
        URL.revokeObjectURL(this.objectURL);
      }
    },
    
    watch: {
      imageBlob(to, from) {
        if(this.objectURL) {
          URL.revokeObjectURL(this.objectURL);
        }
        
        if(to) {
          this.objectURL = URL.createObjectURL(to);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PreviewImage.vue